import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const webChatRoot = (state: State) => state.webChat;

export const chatSelector = createSelector(webChatRoot, (me) => me.chat);
export const avatarSelector = createSelector(webChatRoot, (me) => me.avatar);
export const conversationsSelector = createSelector(webChatRoot, (me) => 
    me.conversations.ids.map((id) => me.conversations.entities[id])
);
export const selectedSelector = createSelector(webChatRoot, (me) => me.selected);
export const messagesSelector = createSelector(webChatRoot, (me) =>
    me.messages.ids.map((id) => me.messages.entities[id])
);
